import { empty } from '../Cause/dist/effect-Cause.esm.js';
import { dual } from '../Function/dist/effect-Function.esm.js';
import { empty as empty$3 } from '../HashMap/dist/effect-HashMap.esm.js';
import { logLevelInfo } from './core.esm.js';
import { none } from './fiberId.esm.js';
import { empty as empty$1 } from './fiberRefs.esm.js';
import { empty as empty$2 } from '../List/dist/effect-List.esm.js';

/** @internal */
const test = /*#__PURE__*/dual(2, (self, input) => self.log({
  fiberId: none,
  logLevel: logLevelInfo,
  message: input,
  cause: empty,
  context: empty$1(),
  spans: empty$2(),
  annotations: empty$3(),
  date: new Date()
}));

export { test };
